import { FC, useState } from "react";
import { Task } from "../../../../../types/task";
import styles from "./index.module.scss";
import { updateTaskStatus } from "../../../../../api/task";
import Loading from 'react-spinners/ClipLoader';
import { Modal } from "@quark/design";

interface TaskActionProps {
  task: Task;
  onStart: () => void;
  onEdit: () => void;
  onSubmit: () => void;
  onView: () => void;
}
const TaskAction: FC<TaskActionProps> = ({
  task,
  onStart,
  onEdit,
  onSubmit,
  onView
}) => {
  const [loading, setLoading] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const start = () => {
    setLoading(true);
    updateTaskStatus(task.id, 'doing')
      .then(() => {
        onStart();
      })
      .finally(() => {
        setLoading(false);
      })
  }

  const submit = () => {
    if (loading) return;
    setConfirmVisible(false);
    setLoading(true);
    updateTaskStatus(task.id, 'check')
      .then(() => {
        onSubmit();
      })
      .finally(() => {
        setLoading(false);
      })
  }

  if (loading) {
    return (
      <Loading size={14} color="#666" />
    )
  }

  if (task.status === 'undo') {
    return (
      <>
        <div
          className={styles.action}
          onClick={start}
        >
          开始
        </div>
        <div className={styles.action} onClick={onView}>
          预览
        </div>
      </>
    )
  }

  if (task.status === 'doing') {
    return (
      <>
        <div className={styles.action} onClick={() => setConfirmVisible(true)}>
          提交审核
        </div>
        <div className={styles.action} onClick={() => onEdit()}>
          编辑
        </div>
        <div className={styles.action} onClick={onView}>
          预览
        </div>
        <Modal title="提交确认" visible={confirmVisible}>
          <div className={styles.confirm}>
            <div className={styles.title}>确认提交审核？</div>
            <div className={styles.content}>提交审核后，您将无法再次编辑。</div>
            <div className={styles.actions}>
              <div className={styles.action} onClick={() => setConfirmVisible(false)}>取消</div>
              <div className={styles.action} onClick={submit}>确认提交</div>
            </div>
          </div>
        </Modal>
      </>
    )
  }

  return (
    <div className={styles.action} onClick={onView}>
      预览
    </div>
  );
}

export default TaskAction;
